<template>
  <div>
    <MenuComponent/>
    <div class="wrap">
      <p class="title-1">Resumen del panel de control</p>
      <p class="title-2">Monitorea los usuarios y compañias en tiempo real</p>

      <div class="screen-display">
        <div class="beauti-card">
          <div style="width: 90%; margin: auto;">
            <div class="icon bg-one">
              <li class="pi pi-user" style="font-size:2rem"></li>
            </div>
            <p class="label-card">Nuevos Usuarios</p>
            <p class="label-number">{{ nuevosusuarios }}</p><br>
          </div>
        </div>
        <div class="beauti-card" @click="abrirClientes">
          <div style="width: 90%; margin: auto;">
            <div class="icon bg-second">
              <li class="pi pi-building" style="font-size:2rem"></li>
            </div>
            <p class="label-card">Total de organizaciones</p>
            <p class="label-number">{{ usuarios }}</p><br>
          </div>
        </div>
        <div class="beauti-card" @click="abrirProspectos">
          <div style="width: 90%; margin: auto;">
            <div class="icon bg-third">
              <li class="pi pi-users" style="font-size:2rem"></li>
            </div>
            <p class="label-card">Total de prospectos</p>
            <p class="label-number">{{ prospectos }}</p><br>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>


<script setup>

import MenuComponent from '@/components/MenuComponent.vue';
import api from '@/plugins/Axios';
import { onMounted, ref } from 'vue';
import {  useRouter } from 'vue-router';
const usuarios = ref(0);
const nuevosusuarios = ref(0);
const prospectos = ref(0);
const router = useRouter();

const obtenerTotalUsuarios = async ()=>{
  try{
    let form = new FormData();
    form.append("getClientes", "");
    const res = await api.post("/Api_Usuario", form);
    usuarios.value = res.data.result.length;
  }
  catch(err)
  {
    console.error(err);
  }
}

const obtenerTotalNuevosUsuarios = async ()=>{
  try{
    let form = new FormData();
    form.append("getNewClientes", "");
    const res = await api.post("/Api_Usuario", form);
    nuevosusuarios.value = res.data.result.length;
  }
  catch(err)
  {
    console.error(err);
  }
}

const ObtenerProspectos = async () =>{
  try{
    let form = new FormData();
    form.append("getProspectos", "");
    const res = await api.post("/Api_Usuario", form);
    prospectos.value = res.data.result.length;
  }
  catch(err)
  {
    console.error(err);
  }
}

const abrirClientes = ()=>{
  router.push("/clientes");
}

const abrirProspectos = ()=>{
  router.push("/prospectos");
}

onMounted(()=>{
  obtenerTotalUsuarios();
  obtenerTotalNuevosUsuarios();
  ObtenerProspectos();
});

</script>


<style scoped>

.title-1
{
  font-size: 1.5rem;
}
.title-2
{
  font-size: 1rem; 
  color: silver;
}
.bg-second
{
  background: #E6FCF5;
  color: #0C8B3D;
}
.bg-third
{
  background: #FAF5FF;
  color: #9333EA;
}

.screen-display
{
  width: 100%;
  gap:1rem;
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
}
.icon
{
  width: 40px;
  padding: 5px;
  height: 40px;
  border-radius: 12px;
  margin-top: 35px;
}
.label-number
{
  font-size: 3em;
  margin-top: 5px;
  font-weight: bold;
}
.label-card
{
  margin-top: 15px;
  font-size: 0.9em;
  color: silver;
}
.bg-one
{
  background: #E7F3FF;
  color: #197FE6;
}
.beauti-card
{
  flex: 1;
  padding: 5px;
  background: white;
  transition: all .45s;
  border-radius: 8px;
  box-shadow: 0px 4px 5px rgb(255, 255, 255);
}

.beauti-card:hover
{
  transition: all .45s;
  transform: scale(1.06,1.06);
  cursor: pointer;
}

@media(max-width:1024px)
{
  .title-1
  {
    font-size: 1.2rem;
  }
  .title-2
  {
    font-size: 0.9rem; 
  }
}

@media(max-width:790px)
{
  .beauti-card
  {
    width: 100%;
    flex: none;
    transition: all .45s;
  }
}

@media (prefers-color-scheme: dark) {
    
    .beauti-card
    {
      background: rgb(0, 0, 0);
      box-shadow: 0px 4px 5px rgb(0, 0, 0);
    }

}

</style>